import React from 'react';
import * as R from 'ramda';
import { FormattedMessage } from 'react-intl';

export default ({ address, fullformat }) => {
  if (fullformat)
    return (
      <address>
        <ul>
          <li>
            <small>
              <FormattedMessage
                id="address-label-street"
                defaultMessage="Street"
              />
            </small>{' '}
            {R.prop('street', address)}
          </li>
          <li>
            <small>
              <FormattedMessage
                id="address-label-suburb"
                defaultMessage="Suburb"
              />
            </small>{' '}
            {R.prop('suburb', address)}
          </li>
          <li>
            <small>
              <FormattedMessage id="address-label-city" defaultMessage="City" />
            </small>{' '}
            {R.prop('city', address)}
          </li>
          <li>
            <small>
              <FormattedMessage
                id="address-label-state"
                defaultMessage="State"
              />
            </small>{' '}
            {R.prop('state', address)}
          </li>
          <li>
            <small>
              <FormattedMessage
                id="address-label-region"
                defaultMessage="Region"
              />
            </small>{' '}
            {R.prop('region', address)}
          </li>
          <li>
            <small>
              <FormattedMessage
                id="address-label-country"
                defaultMessage="Country"
              />
            </small>{' '}
            {R.pathOr('n/a', ['country', 'name'], address)}
          </li>
          <li>
            <small>
              <FormattedMessage id="address-label-zip" defaultMessage="Zip" />
            </small>{' '}
            {R.prop('zip', address)}
          </li>
        </ul>
      </address>
    );

  return (
    <address>
      {R.prop('street', address)} {R.prop('suburb', address)}{' '}
      {R.prop('city', address)} {R.prop('state', address)}{' '}
      {R.prop('region', address)} {R.path(['country', 'name'], address)}{' '}
      <span className="nowrap">{R.prop('zip', address)}</span>
    </address>
  );
};
